require('../../modules/es6.object.freeze');
module.exports = require('../../modules/_core').Object.freeze;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/fn/object/freeze.js
// module id = 122
// module chunks = 0